module.exports = __webpack_public_path__ + "static/media/60-iveco.d2f32a63.jpg";